export function showLocalNum(numString) {
    if (numString) {
        return parseInt(numString, 10).toLocaleString();
    }
    return "N/A";
}

export function validDate(dateRange) {
    if (dateRange.start && dateRange.end) {
        if (dateRange.end < dateRange.start) {
            return false;
        }
    }
    return true;
}

export function showLocalDate(date) {
    const options = { timeZone: 'UTC', year: 'numeric', month: 'numeric', day: 'numeric' };
    return new Date(date).toLocaleDateString("en-US", options);
}

export function showLocalDateTime(date) {
    return new Date(date).toLocaleString("en-US");
}

export function showFormatPhoneNumber(phoneNumber) {
    if (phoneNumber && phoneNumber.length === 10) {
        return (
            "(" +
            phoneNumber.substring(0, 3) +
            ") " +
            phoneNumber.substring(3, 6) +
            " - " +
            phoneNumber.substring(6, 10)
        );
    }
}
